import { useEffect, useState, useRef } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";
import { useQueryClient } from "@tanstack/react-query";
import {
  update_paso,
  obtenerErroresProcesoMatricula,
  generateCproceso,
  postGenerarProcesarProyeccionMutation,
  insertCierreMatriculaControlado,
} from "../services/procesoMatricula/procesoMatricula";
import ModalConfirmacionHorario from "./Horario/ModalConfirmacionHorario";
import { cGmatricula, codigoApp } from "../config/constantes";

const SeleccionHorario = () => {
  let { setIdAsignaturas, obtenerDatosEstudiante, gruposHabilitados } = useMatricula();
  const queryClient = useQueryClient();
  let {
    setPasoProcesoM,
    pasoProcesoM,
    setPasoSegundaVistaProcesoM,
    listAsignaturasAgregadas,
    setStrInsertarHorario,
    setLoading,
    setErrorCursoServices,
  } = useProcesoMatricula();

  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});
  const {
    cinstitucion,
    cprograma,
    cperiodo,
    cpersona,
    finiciomatricula,
    ffinmatricula,
    pasomatricula,
    fsistema,
    dciclo,
    dperiodo,
    gmatricula,
    calumno,
  } = obtenerDatosEstudiante;
  const [transaccion, setTransaccion] = useState("");

  const [errorProcesoFinalizado, setErrorProcesoFinalizado] = useState(null);
  const [errorCierreExitoso, setErrorCierreExitoso] = useState(null);
  const [nuevoProceso, setNuevoProceso] = useState(null);

  const cprocesoRef = useRef(generateCproceso() || "defaultValue");
  const [____, setIsPolling] = useState(false);
  const [process, setProcess] = useState("idle");


  useEffect(() => {
    let car = gruposHabilitados.map((e) => {
      return e.ntransaccion;
    });
    setTransaccion(car);
  }, [listAsignaturasAgregadas]);

  useEffect(() => {
    const fetchErrores = async () => {
      try {
        const Response = await obtenerErroresProcesoMatricula({
          p_cpersona: Number(cpersona),
          p_calumno: Number(calumno),
          p_ccarrera: Number(cprograma),
          p_cperiodo: Number(cperiodo),
          p_caplicacion: Number(codigoApp),
          p_cinstitucion: Number(cinstitucion)
        });
        if (Response?.Data?.length > 0) {
          let procesoFinalizado = Response.Data[0].proceso_finalizado;
          let cierreExitoso = Response.Data[0].cierre_exitoso;
          let nuevoProceso = Response.Data[0].es_primer_registro;

          if (procesoFinalizado === 0) {
            setErrorProcesoFinalizado(false);
          } else {
            setErrorProcesoFinalizado(true);
          }
          if (cierreExitoso === 0) {
            setErrorCierreExitoso(false);
          } else {
            setErrorCierreExitoso(true);

          }
          if (nuevoProceso === 1) {
            setNuevoProceso(true);
          } else {
            setNuevoProceso(false);
          }
        }
      } catch (error) {
      }
    };

    fetchErrores();
  }, [cpersona, calumno, cprograma, cperiodo, codigoApp, cinstitucion]);


  useEffect(() => {
    if (errorProcesoFinalizado && errorCierreExitoso) {
      const actualizarPaso = async () => {
        const pasosOk = await update_paso(obtenerDatosEstudiante, 4, 1);
        if (pasosOk.StatusCode == 200 && pasosOk.Code == 1) {
          let pasoSiguiente = Number(pasosOk.Data.paso_siguiente);
          setPasoProcesoM(pasoSiguiente > 0 ? pasoSiguiente - 1 : pasoSiguiente);
          let vistaPago = Number(pasosOk.Data.vistapago_siguiente);
          setPasoSegundaVistaProcesoM(vistaPago === 1 ? false : true);
        } else {
          setErrorCursoServices(pasosOk.Message || "No se pudo actualizar el paso.");

        }
      };
      actualizarPaso();
    }
  }, [errorProcesoFinalizado, errorCierreExitoso]);


  const generarProyeccionGenerarProceso = async () => {
    return postGenerarProcesarProyeccionMutation({
      p_accion: "I",
      p_cproceso: cprocesoRef.current,
      p_cpersona: Number(cpersona),
      p_calumno: Number(calumno),
      p_ccarrera: Number(cprograma),
      p_cperiodo: Number(cperiodo),
      p_caplicacion: Number(codigoApp),
      p_cinstitucion: Number(cinstitucion)
    });
  };

  const consultarProyeccionGenerarProceso = async () => {
    return postGenerarProcesarProyeccionMutation({
      p_accion: "Q",
      p_cproceso: cprocesoRef.current,
      p_cpersona: Number(cpersona),
      p_calumno: Number(calumno),
      p_ccarrera: Number(cprograma),
      p_cperiodo: Number(cperiodo),
      p_caplicacion: Number(codigoApp),
      p_cinstitucion: Number(cinstitucion)
    });
  };

  const strArmarCadenaIns = () => {
    let casignaturaIns;

    listAsignaturasAgregadas.map((e, index) => {
      if (index === 0) {
        casignaturaIns =
          e.scurso +
          "," +
          e.sequivalente +
          "," +
          e.cgrupo +
          "," +
          e.sgrupo +
          "," +
          e.nveces;
      } else {
        casignaturaIns +=
          "|" +
          e.scurso +
          "," +
          e.sequivalente +
          "," +
          e.cgrupo +
          "," +
          e.sgrupo +
          "," +
          e.nveces;
      }
    });
    return casignaturaIns;
  };

  const strArmarCadenaDel = () => {
    let count = 0;
    let listaAgregados = listAsignaturasAgregadas;

    let gruposEscogidosBd = gruposHabilitados.filter((grupo) => {
      return grupo.basignado == true;
    });

    let eliminados1 = gruposEscogidosBd.filter((gruposBd) => {
      let condicional = listaAgregados.some(
        (da) =>
          da.casignatura == gruposBd.casignatura && da.cgrupo == gruposBd.cgrupo
      );

      if (!condicional) {
        return gruposBd;
      }
    });


    let casignaturaDel1 = "";
    eliminados1.forEach((e) => {
      if (count === 0) {
        casignaturaDel1 = e.casignatura + "," + e.cgrupo;
      } else {
        casignaturaDel1 += "|" + e.casignatura + "," + e.cgrupo;
      }
      count++;
    });

    return casignaturaDel1;
  };


  const validarBtnSeleccionHorario = async () => {

    try {
      const nuevoCproceso = generateCproceso();
      cprocesoRef.current = nuevoCproceso;

      // Invalidar las queries existentes para forzar refetch con nuevos parámetros
      await queryClient.invalidateQueries({
        queryKey: ["generarProcesos", { accion: "I", cproceso: cprocesoRef.current }]
      });

      await queryClient.invalidateQueries({
        queryKey: ["generarProcesos", { accion: "Q", cproceso: cprocesoRef.current }]
      });

      setProcess("start");
      setLoading(true);
      const procesoResponse = await generarProyeccionGenerarProceso();
      try {
        const cierreMatricula = await insertCierreMatriculaControlado(obtenerDatosEstudiante, {
          cursosmatriculados: String(strArmarCadenaIns()),
          ntransaccion: Number(gruposHabilitados[0].ntransaccion),
          cproceso: cprocesoRef.current,
          ccarrera: cprograma,
          caplicacion: codigoApp
        });

      } catch (error) {
        if (error.status === 504) {
          pollProcess();
        }
      }
      const pollProcess = async () => {
        setLoading(true);
        setIsPolling(true);
        const result = await consultarProyeccionGenerarProceso();
        const {
          gestado,
          nrespuesta_proceso,
          mensaje_usuario_proceso,
        } = result?.Data[0] || {};
        if (Number(nrespuesta_proceso) === 500) {
          // Mostrar mensaje de error del proceso
          setErrorCursoServices(mensaje_usuario_proceso || "No se pudo cerrar la matrícula correctamente.");
          const modalErrorr = document.querySelector("#modalErr");
          if (modalErrorr) modalErrorr.click();
          setIsPolling(false); // Detener polling en caso de error
          setLoading(false);
        } else if (Number(gestado) === 1) {
          const pasosOk = await update_paso(obtenerDatosEstudiante, 4, 1);
          if (pasosOk.StatusCode == 200 && pasosOk.Code == 1) {
            let convertirPasoCompletadoMayoCero = Number(pasosOk.Data.paso_siguiente);
            let convertirPasoCompletado = convertirPasoCompletadoMayoCero > 0 ? convertirPasoCompletadoMayoCero - 1
              : convertirPasoCompletadoMayoCero;
            setPasoProcesoM(convertirPasoCompletado);
            let vistapago_siguientes = Number(pasosOk.Data.vistapago_siguiente);
            let convertirSegundoPaso = vistapago_siguientes == 1 ? false : true;
            setPasoSegundaVistaProcesoM(convertirSegundoPaso);
          } else {
            setErrorCursoServices(pasosOk.Message || "No se pudo actualizar el paso.");
            const modalErrorr = document.querySelector("#modalErr");
            if (modalErrorr) modalErrorr.click();
            setLoading(false);
            setIsPolling(false);
          }
          setIsPolling(false);
          setProcess("finish");
        } else {
          // Continuar haciendo polling cada 10 segundos si gestado no es 1
          setTimeout(pollProcess, 10000);
        }
      };
      pollProcess();
    } catch (error) {
      setIsPolling(false);
      setProcess("finish");
    }
  };


  const atrasBtnSeleccionHorario = () => {
    setStrInsertarHorario("");
    //Despues setear los campos de estado
    if (dciclo == "I") {
      setPasoProcesoM(2);
    } else {
      setPasoSegundaVistaProcesoM(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (pasoProcesoM == 3) {
        if (dciclo == "I") {
          let modal = document.querySelector("#horarioRegistrado");
          if (modal) {
            modal.click();
          }
        }
      }
    }, 1000);
  }, [pasoProcesoM]);

  useEffect(() => {
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        global_seleccion_horario: obtenerLabelEtiqueta(
          "lbl_global_seleccion_horario",
          listadoEtiquetas
        ),
        horario_confirmacion: obtenerLabelEtiqueta(
          "lbl_horario_confirmacion",
          listadoEtiquetas
        ),
        msj_resumen_horario: obtenerLabelEtiqueta(
          "lbl_horario_msj_resumen_horario",
          listadoEtiquetas
        ),
        global_cod: obtenerLabelEtiqueta("lbl_global_cod", listadoEtiquetas),
        global_asignatura: obtenerLabelEtiqueta(
          "lbl_global_asignatura",
          listadoEtiquetas
        ),
        global_grupo: obtenerLabelEtiqueta(
          "lbl_global_grupo",
          listadoEtiquetas
        ),
        horario_tipo: obtenerLabelEtiqueta(
          "lbl_horario_tipo",
          listadoEtiquetas
        ),
        global_horario: obtenerLabelEtiqueta(
          "lbl_global_horario",
          listadoEtiquetas
        ),
        global_inicio: obtenerLabelEtiqueta(
          "lbl_global_inicio",
          listadoEtiquetas
        ),
        global_fin: obtenerLabelEtiqueta("lbl_global_fin", listadoEtiquetas),
        global_docente: obtenerLabelEtiqueta(
          "lbl_global_docente",
          listadoEtiquetas
        ),
        global_ciclo: obtenerLabelEtiqueta(
          "lbl_global_ciclo",
          listadoEtiquetas
        ),
        global_sumilla: obtenerLabelEtiqueta(
          "lbl_global_sumilla",
          listadoEtiquetas
        ),
        global_vez: obtenerLabelEtiqueta("lbl_global_vez", listadoEtiquetas),
        global_cred: obtenerLabelEtiqueta("lbl_global_cred", listadoEtiquetas),
        msj_total_creditos: obtenerLabelEtiqueta(
          "lbl_horario_msj_total_creditos",
          listadoEtiquetas
        ),
        horario_t_asignaturas: obtenerLabelEtiqueta(
          "lbl_horario_t_asignaturas",
          listadoEtiquetas
        ),
        horario_t_tipo_asignatura: obtenerLabelEtiqueta(
          "lbl_horario_t_tipo_asignatura",
          listadoEtiquetas
        ),
        horario_t_creditos: obtenerLabelEtiqueta(
          "lbl_horario_t_creditos",
          listadoEtiquetas
        ),
        global_t_horas: obtenerLabelEtiqueta(
          "lbl_global_t_horas",
          listadoEtiquetas
        ),
        horario_asignaturas: obtenerLabelEtiqueta(
          "lbl_horario_asignaturas",
          listadoEtiquetas
        ),
        horario_obli: obtenerLabelEtiqueta(
          "lbl_horario_obli",
          listadoEtiquetas
        ),
        global_elec: obtenerLabelEtiqueta("lbl_global_elec", listadoEtiquetas),
        global_com: obtenerLabelEtiqueta("lbl_global_com", listadoEtiquetas),
        reglamento_volver: obtenerLabelEtiqueta(
          "lbl_reglamento_volver",
          listadoEtiquetas
        ),
        datos_continuar: obtenerLabelEtiqueta(
          "lbl_update_datos_continuar",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);
  const {
    global_seleccion_horario,
    horario_confirmacion,
    msj_resumen_horario,
    global_cod,
    global_asignatura,
    global_grupo,
    horario_tipo,
    global_horario,
    global_inicio,
    global_fin,
    global_docente,
    global_ciclo,
    global_sumilla,
    global_vez,
    global_cred,
    msj_total_creditos,
    horario_t_asignaturas,
    horario_t_tipo_asignatura,
    horario_t_creditos,
    global_t_horas,
    horario_asignaturas,
    horario_obli,
    global_elec,
    global_com,
    reglamento_volver,
    datos_continuar,
  } = etiquetas;

  let countC = 0;
  let countE = 0;
  let countO = 0;
  let creditosCount = 0;
  let horasCount = 0;


  listAsignaturasAgregadas.map((data) => {
    if (data.gtipo === "C") {
      countC++;
    }
    if (data.gtipo === "E") {
      countE++;
    }
    if (data.gtipo === "O") {
      countO++;
    }
    let creditos = data.ncreditos;
    creditosCount = creditosCount + creditos;
    let horas = data.nhoras;
    horasCount = horasCount + horas;
  });


  const validarGmatricula = (gmatricula) => {
    let splitCGmatricula = cGmatricula.split(",")
    return splitCGmatricula.includes(String(gmatricula))
  }

  return (
    <div className="col-sm-12 col-md-12 col-lg-12 steps-container ">
      <div className="card shadow-sm">
        <div className="card-body">
          <fieldset>
            <div className="form-body">
              <div className="matricula-title">
                <h5 className="text-uppercase">{global_seleccion_horario}</h5>
                <div className="separator"></div>
              </div>
              <div className="row mb-4">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <p className="text-uppercase fw-bolder">
                    {horario_confirmacion}
                  </p>
                  <p>
                    {msj_resumen_horario}.
                  </p>

                  <div className="d-block  d-md-none d-lg-none resumen-responsive">
                    {listAsignaturasAgregadas.map((data, index) => {
                      return (
                        <div className="border rounded-3" key={index}>
                          <div className="d-flex p-2 justify-content-between bg-secondary-lighter">
                            <p className="fw-bold me-4 mb-0">{data.scurso}</p>
                            <p className="mb-0">{data.dcurso}</p>


                            {
                              <OverlayTrigger
                                placement="right"
                                overlay={
                                  <Tooltip id={data.gtipo}>
                                    {data.ctipo}
                                  </Tooltip>
                                }
                              >
                                <button
                                  className={` ms-3 fs-sm ${data.gtipo === "C"
                                    ? "icon-com"
                                    : data.gtipo === "E"
                                      ? "icon-ele"
                                      : data.gtipo === "O"
                                        ? "icon-obli"
                                        : ""
                                    }`}
                                >
                                  <span variant="secondary">{data.gtipo}</span>{" "}
                                </button>
                              </OverlayTrigger>
                            }
                          </div>
                          <div className=" border-top  p-2">
                            <div className="d-flex justify-content-start">
                              <p className="fw-medium me-2 mb-0 w-25">
                                {global_grupo}
                              </p>
                              <p className="fw-medium me-2 mb-0 ">
                                {data.sgrupo}
                              </p>
                            </div>
                            <div className="d-flex justify-content-start">
                              <p className="fw-medium me-2 mb-0 w-25">
                                {global_horario}
                              </p>
                              <p className="fw-medium me-2 mb-0 ">
                                {data.dhorario}{" "}
                              </p>
                            </div>
                            <div className="d-flex justify-content-start">
                              <p className="fw-medium me-2 mb-0 w-25">
                                {global_inicio}
                              </p>
                              <p className="fw-medium me-2 mb-0 ">
                                {data.finicio}{" "}
                              </p>
                            </div>
                            <div className="d-flex justify-content-start">
                              <p className="fw-medium me-2 mb-0 w-25">
                                {global_fin}
                              </p>
                              <p className="fw-medium me-2 mb-0 ">
                                {data.ffin}{" "}
                              </p>
                            </div>
                            <div className="d-flex justify-content-start">
                              <p className="fw-medium me-2 mb-0 w-25">
                                {global_docente}
                              </p>
                              <p className="fw-medium me-2 mb-0 ">
                                {data.ddocente}{" "}
                              </p>
                            </div>
                            <div className="d-flex justify-content-start">
                              <p className="fw-medium me-2 mb-0 w-25">
                                {global_ciclo}
                              </p>
                              <p className="fw-medium me-2 mb-0 ">
                                {data.cciclo}{" "}
                              </p>
                            </div>
                            <div className="d-flex justify-content-start">
                              <p className="fw-medium me-2 mb-0 w-25">
                                {global_sumilla}
                              </p>
                              <div>
                                <button
                                  className="btn btn-sumilla"
                                  type="button"
                                  style={{ marginLeft: "-4px!important" }}
                                  data-bs-toggle="modal"
                                  data-bs-target="#sumilla"
                                  onClick={() => {
                                    setIdAsignaturas(data.scurso);
                                  }}
                                >
                                  <svg
                                    width="13"
                                    height="13"
                                    viewBox="0 0 13 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M6.01675 4.71675H7.31675V3.41675H6.01675M6.66675 11.8667C3.80025 11.8667 1.46675 9.53325 1.46675 6.66675C1.46675 3.80025 3.80025 1.46675 6.66675 1.46675C9.53325 1.46675 11.8667 3.80025 11.8667 6.66675C11.8667 9.53325 9.53325 11.8667 6.66675 11.8667ZM6.66675 0.166748C5.81316 0.166748 4.96792 0.334876 4.17931 0.661531C3.39069 0.988187 2.67413 1.46697 2.07055 2.07055C0.851567 3.28954 0.166748 4.94284 0.166748 6.66675C0.166748 8.39065 0.851567 10.044 2.07055 11.2629C2.67413 11.8665 3.39069 12.3453 4.17931 12.672C4.96792 12.9986 5.81316 13.1667 6.66675 13.1667C8.39065 13.1667 10.044 12.4819 11.2629 11.2629C12.4819 10.044 13.1667 8.39065 13.1667 6.66675C13.1667 5.81316 12.9986 4.96792 12.672 4.17931C12.3453 3.39069 11.8665 2.67413 11.2629 2.07055C10.6594 1.46697 9.94281 0.988187 9.15419 0.661531C8.36557 0.334876 7.52034 0.166748 6.66675 0.166748M6.01675 9.91675H7.31675V6.01675H6.01675V9.91675Z"
                                      fill="#FFC702"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>
                            <div className="d-flex justify-content-start">
                              <p className="fw-medium me-2 mb-0 w-25">
                                {global_vez}
                              </p>
                              <p className="fw-medium me-2 mb-0 ">
                                {data.nveces}{" "}
                              </p>
                            </div>
                            <div className="d-flex justify-content-start">
                              <p className="fw-medium me-2 mb-0 w-25">
                                {global_cred}
                              </p>
                              <p className="fw-medium me-2 mb-0 ">
                                {data.ncreditos}{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="table-responsive table-schedule border-body table-schedule d-none d-md-block d-lg-block">
                    <table className="table table-striped ">
                      <thead className="table-light">
                        <tr>
                          {/* <th scope="col">{global_cod}.</th> */}
                          <th scope="col">{global_asignatura}</th>
                          <th scope="col">Equivalente</th>
                          <th scope="col">{global_grupo}</th>

                          <th scope="col" style={{ textAlign: "center" }}>
                            {horario_tipo}
                          </th>
                          <th scope="col">Modalidad</th>
                          <th scope="col">{global_horario}</th>
                          <th scope="col">{global_inicio}</th>
                          <th scope="col">{global_fin}</th>
                          <th scope="col">{global_docente}</th>
                          <th scope="col">{global_ciclo}</th>
                          <th scope="col">{global_sumilla}</th>
                          <th scope="col">{global_vez}</th>
                          <th scope="col">{global_cred}.</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listAsignaturasAgregadas.map((data, index) => {
                          return (
                            <tr key={index}>
                              {/* <th scope="row">{data.scurso} </th> */}
                              <th scope="row">
                                <strong>{data.scurso}</strong> - {data.dcurso}{" "}
                              </th>
                              <td>
                                {" "}
                                <strong>{data.sequivalente}</strong> -{" "}
                                {data.dequivalente}
                              </td>
                              <td>{data.sgrupo}</td>

                              <td>
                                {
                                  <OverlayTrigger
                                    placement="right"
                                    overlay={
                                      <Tooltip id={data.gtipo}>
                                        {data.ctipo}
                                      </Tooltip>
                                    }
                                  >
                                    <button
                                      className={` ms-3 fs-sm ${data.gtipo === "C"
                                        ? "icon-com"
                                        : data.gtipo === "E"
                                          ? "icon-ele"
                                          : data.gtipo === "O"
                                            ? "icon-obli"
                                            : ""
                                        }`}
                                    >
                                      <span variant="secondary">
                                        {data.gtipo}
                                      </span>{" "}
                                    </button>
                                  </OverlayTrigger>
                                }
                              </td>

                              <td>{data.dmodalidad}</td>
                              <td>{data.dhorario} </td>

                              <td>{data.finicio} </td>
                              <td>{data.ffin} </td>
                              <td>{data.ddocente} </td>
                              <td>{data.cciclo}</td>
                              <td>
                                <button
                                  className="btn btn-sumilla"
                                  type="button"
                                  data-bs-toggle="modal"
                                  data-bs-target="#sumilla"
                                  onClick={() => {
                                    setIdAsignaturas(data.scurso);
                                  }}
                                >
                                  <svg
                                    width="13"
                                    height="13"
                                    viewBox="0 0 13 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M6.01675 4.71675H7.31675V3.41675H6.01675M6.66675 11.8667C3.80025 11.8667 1.46675 9.53325 1.46675 6.66675C1.46675 3.80025 3.80025 1.46675 6.66675 1.46675C9.53325 1.46675 11.8667 3.80025 11.8667 6.66675C11.8667 9.53325 9.53325 11.8667 6.66675 11.8667ZM6.66675 0.166748C5.81316 0.166748 4.96792 0.334876 4.17931 0.661531C3.39069 0.988187 2.67413 1.46697 2.07055 2.07055C0.851567 3.28954 0.166748 4.94284 0.166748 6.66675C0.166748 8.39065 0.851567 10.044 2.07055 11.2629C2.67413 11.8665 3.39069 12.3453 4.17931 12.672C4.96792 12.9986 5.81316 13.1667 6.66675 13.1667C8.39065 13.1667 10.044 12.4819 11.2629 11.2629C12.4819 10.044 13.1667 8.39065 13.1667 6.66675C13.1667 5.81316 12.9986 4.96792 12.672 4.17931C12.3453 3.39069 11.8665 2.67413 11.2629 2.07055C10.6594 1.46697 9.94281 0.988187 9.15419 0.661531C8.36557 0.334876 7.52034 0.166748 6.66675 0.166748M6.01675 9.91675H7.31675V6.01675H6.01675V9.91675Z"
                                      fill="#FFC702"
                                    />
                                  </svg>
                                </button>{" "}
                              </td>
                              <td>{data.nveces} </td>
                              <td>{data.ncreditos}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  <p className="text-uppercase fw-bolder mt-4">
                    {msj_total_creditos}
                  </p>
                  <div className="total-resumen border rounded-3  mt-3 d-md-none d-lg-none ">
                    <div className="d-flex justify-content-between border-bottom px-2 py-1">
                      <p className="fw-bold w-50 me-1 mb-0">
                        Total Asignaturas
                      </p>
                      <p className="fw-medium me-1 mb-0">
                        {listAsignaturasAgregadas.length}{" "}
                      </p>
                    </div>
                    <div className="d-flex justify-content-between border-bottom px-2 py-1">
                      <p className="fw-bold w-50 me-1 mb-0">
                        Total Obligatorio
                      </p>
                      <p className="fw-medium me-1 mb-0 color-obli">{countO}</p>
                    </div>
                    <div className="d-flex justify-content-between border-bottom px-2 py-1">
                      <p className="fw-bold w-50 me-1 mb-0">Total Electivo</p>
                      <p className="fw-medium me-1 mb-0 color-ele">{countE} </p>
                    </div>
                    <div className="d-flex justify-content-between border-bottom px-2 py-1">
                      <p className="fw-bold w-50 me-1 mb-0">
                        Total Complementario
                      </p>
                      <p className="fw-medium me-1 mb-0 color-com">{countC} </p>
                    </div>
                    <div className="d-flex justify-content-between border-bottom px-2 py-1">
                      <p className="fw-bold w-50 me-1 mb-0">Total Créd.</p>
                      <p className="fw-medium me-1 mb-0">{creditosCount}</p>
                    </div>
                    <div className="d-flex justify-content-between px-2 py-1">
                      <p className="fw-bold w-50 me-1 mb-0">Total horas.</p>
                      <p className="fw-medium me-1 mb-0">{horasCount} </p>
                    </div>
                  </div>
                  <div className="table-responsive table-schedule d-none d-md-block d-lg-block">
                    <table className="table table-striped">
                      <thead className="table-light">
                        <tr>
                          <th scope="col">{horario_t_asignaturas}</th>
                          <th scope="col">{horario_t_tipo_asignatura}</th>
                          <th scope="col">{horario_t_creditos}</th>

                          <th scope="col">{global_t_horas}</th>
                        </tr>
                      </thead>

                      <tfoot>
                        <tr>
                          <th scope="row">
                            {listAsignaturasAgregadas.length}{" "}
                            {horario_asignaturas}{" "}
                          </th>

                          <td>
                            <span className="color-obli">{countO}</span>{" "}
                            {horario_obli}.{" "}
                            <span className="color-ele">{countE}</span>{" "}
                            {global_elec}.{" "}
                            <span className="color-com">{countC}</span>{" "}
                            {global_com}.
                          </td>
                          <td>{creditosCount}</td>
                          <td>{horasCount} </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <div className="mt-4">
                  <div className={`alert  ${validarGmatricula(gmatricula) == false ? "alert-warning" : "alert-success"}`} role="alert">
                    <p className="mb-0" style={{ lineHeight: "1.2" }}>
                      <svg
                        style={{ width: 24, height: 24, marginRight: 5 }}
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                        />
                      </svg>
                      {gmatricula && validarGmatricula(gmatricula) == true ? "Está en el proceso de pre-matrícula, por lo tanto no puede confirmar. Cuando se encuentre en las fechas de matrícula regular o extemporánea podrá continuar." : "Favor de revisar detenidamente las asignaturas y grupos seleccionados. Una vez que realice la confirmación no podrá revertir lo seleccionado."}
                    </p>
                  </div>
                  {/* Mensaje informativo según el estado del proceso */}
                  {
                    errorProcesoFinalizado !== null && nuevoProceso !== null && (
                      !errorProcesoFinalizado && !nuevoProceso ? (
                        <div className="alert alert-danger" role="alert">
                          <p className="mb-0" style={{ lineHeight: "1.2" }}>
                            <svg style={{ width: 24, height: 24, marginRight: 5 }}
                              viewBox="0 0 24 24">
                              <path
                                fill="currentColor"
                                d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                              />
                            </svg>
                            Usted ha generado previamente un proceso de cierre de matrícula, por favor espere que finalice.
                          </p>
                        </div>
                      ) : errorProcesoFinalizado && errorCierreExitoso ? (
                        <div className="alert alert-success" role="alert">
                          <p className="mb-0" style={{ lineHeight: "1.2" }}>
                            <svg style={{ width: 24, height: 24, marginRight: 5 }}
                              viewBox="0 0 24 24">
                              <path
                                fill="currentColor"
                                d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                              />
                            </svg>
                            El cierre de matrícula se realizó con éxito. Se le llevara al siguiente paso.
                          </p>
                        </div>
                      ) : null
                    )}
                </div>
              </div>
            </div>
            <button
              type="button"
              className="btn waves-effect waves-light btn-light-secondary previous"
              onClick={atrasBtnSeleccionHorario}
            >
              {reglamento_volver}
            </button>
            {

              (!errorProcesoFinalizado && !nuevoProceso || (gmatricula && validarGmatricula(gmatricula) == true)) ? (
                <button
                  type="button"
                  className="btn waves-effect waves-light btn-secondary siguiente"
                  disabled
                >
                  Confirmar
                </button>
              ) : errorProcesoFinalizado && !errorCierreExitoso ? (
                // Si el proceso finalizó pero el cierre no fue exitoso: habilitamos el botón para reintentar.
                <button
                  type="button"
                  className="btn waves-effect waves-light btn-primary next"
                  data-bs-toggle="modal"
                  data-bs-target="#confirmacion-horario"
                // onClick={validarBtnSeleccionHorario}
                >
                  Confirmar
                </button>
              ) : errorProcesoFinalizado && errorCierreExitoso ? (
                // Si el proceso finalizó y el cierre fue exitoso: el botón queda bloqueado.e inmediatamente actualizará el paso
                <button
                  type="button"
                  className="btn waves-effect waves-light btn-secondary siguiente"
                  disabled
                >
                  Confirmar
                </button>
              ) : nuevoProceso ? (
                <button
                  type="button"
                  className="btn waves-effect waves-light btn-primary next"
                  data-bs-toggle="modal"
                  data-bs-target="#confirmacion-horario"
                // onClick={validarBtnSeleccionHorario}
                >
                  Confirmar
                </button>
              ) : null



            }
            <button
              id="horarioRegistrado"
              className="btn btn-sumilla"
              style={{ display: "none" }}
              data-bs-toggle="modal"
              data-bs-target="#horarioregistrado"
              onClick={() => { }}
            ></button>
          </fieldset>
        </div>
      </div>

      <button
        style={{ display: "none" }}
        data-bs-toggle="modal"
        data-bs-target="#error"
        id="modalErr"
      >
      </button>
      <ModalConfirmacionHorario guardarSeleccion={validarBtnSeleccionHorario} />
    </div>
  );
};

export default SeleccionHorario;